import React from 'react'
import Header from '../component/Header/Header'
import FooterNew from '../component/FooterNew/FooterNew'
import TeamCustomContent from '../component/TeamCustomContent/TeamCustomContent'

function Team() {
  return (
    <div>
         <Header/>

        <TeamCustomContent/>
        
        <FooterNew/>
    </div>
  )
}

export default Team